import fb from '@/firebaseConfig';
import { sortByTitle } from '@/helpers/contentHelpers';
/*

  STATE

 */

const state = {
  favoriteIds: [],
  favoriteStackIds: [],
};

/*

  GETTERS

 */

const getters = {
  sortedFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    const unsortedIds = state.favoriteIds;
    return sortByTitle(allCards, unsortedIds);
  },

  journeyFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id =>
      allCards[id] ? allCards[id].category === 'journey' : false
    );
  },

  deepeningFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id =>
      allCards[id] ? allCards[id].category === 'deepening' : false
    );
  },

  lighteningFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id =>
      allCards[id] ? allCards[id].category === 'lightening' : false
    );
  },

  sortedFavStackIds: (state, getters, rootState, rootGetters) => {
    const allStacks = rootGetters['stacks/allStacks'];
    const unsortedIds = state.favoriteStackIds;
    return sortByTitle(allStacks, unsortedIds);
  },

  indexInFavorites: (state, getters, rootState) => {
    const { currentId, routeName } = rootState.ui;
    const { sortedFavIds, sortedFavStackIds } = getters;
    if (routeName === 'Stack') {
      return sortedFavStackIds.indexOf(currentId);
    }
    return sortedFavIds.indexOf(currentId);
  },
};

/*

  ACTIONS

 */

const actions = {
  toggleFavorite({ commit, dispatch, getters, rootState }) {
    const { currentId: id, routeName } = rootState.ui;
    const { uid } = rootState.user;
    const { sortedFavIds, sortedFavStackIds, indexInFavorites } = getters;
    const type = routeName === 'Stack' ? 'Stack' : '';
    let favoriteIds = [...sortedFavIds];
    if (routeName === 'Stack') {
      favoriteIds = [...sortedFavStackIds];
    }

    if (indexInFavorites === -1) {
      favoriteIds.push(id);
      dispatch(`analytics/saveFavorite${type}`, id, { root: true });
    } else {
      favoriteIds.splice(indexInFavorites, 1);
      dispatch(`analytics/removeFavorite${type}`, id, { root: true });
    }
    commit(`setFavorite${type}s`, favoriteIds);

    fb.usersCollection
      .doc(uid)
      .set(
        {
          [`favorite${type}Ids`]: favoriteIds,
        },
        { merge: true }
      )
      .catch(error => {
        console.error('Error writing document: ', error);
      });
  },
};

/*

  MUTATIONS

 */

const mutations = {
  setFavorites(state, favoriteIds) {
    if (favoriteIds) {
      state.favoriteIds = favoriteIds;
    }
  },

  setFavoriteStacks(state, favoriteIds) {
    if (favoriteIds) {
      state.favoriteStackIds = favoriteIds;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
